<template>
  <div class="wkf-configuracao">
    <v-breadcrumbs class="systock-breadcrump">
      <v-breadcrumbs-item :title="breadcrumb">
        {{ breadcrumb }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>
    <autorizacao />
  </div>
</template>
<script>
import autorizacao from "./Autorizacao";

export default {
  name: "WKFConfiguracao",
  components: {
    autorizacao,
  },
  data() {
    return {
      breadcrumb: "WORKFLOW / AUTORIZAÇÃO",
    };
  },
};
</script>
<style>
.wkf-configuracao .v-icon.mdi-pencil:hover {
  color: blue;
}
.wkf-configuracao .v-icon.mdi-delete:hover {
  color: red;
}
.wkf-configuracao .input-descricao input {
  text-transform: uppercase;
}

.systock-breadcrump {
  background-color: #7979790a;
  height: 2.5em;
}
.wkf-configuracao .v-btn:not(.v-btn--round).v-size--default {
  height: 40px;
}
.wkf-configuracao .v-data-footer__select .v-select {
  margin: 4px 0 6px 16px !important;
}
.wkf-configuracao .v-data-table .v-toolbar__content {
  border-bottom: 1px solid #e0e0e0;
}
.wkf-configuracao .v-data-table--fixed-header .v-data-footer {
  margin-right: 0;
  padding-right: 16px;
}

.wkf-configuracao .v-tabs .v-tabs-bar {
  background-color: #7979790a !important;
}

.v-tabs-bar__content {
  border-bottom: 1px solid #f7f1f1;
  border-top: 1px solid #f7f1f1;
}

.v-card__actions {
  border-top: 1px solid #e0e0e0;
}

.autorizacao-top-bar .table-wkf-resposivo-autorizacao > .v-data-table__wrapper {
  height: calc(100vh - 171px) !important;
}
.table-wkf-resposivo-autorizacao > .v-data-table__wrapper {
  height: calc(100vh - 203px) !important;
}
.btn-autorizar-all {
  margin-top: -10px;
}
.btn-autorizar-all .btn-text {
  position: absolute;
  font-size: 10px;
  margin-top: 17px;
  font-weight: 800;
  letter-spacing: -0.6px;
  margin-left: -28px;
}
</style>
